export const DISCOUNT_CODE_FIELD = 'discountCode';

export interface DiscountCodeFormValues {
  [DISCOUNT_CODE_FIELD]: string;
}

export const DISCOUNT_CODE_FORM_INITIAL_VALUE: DiscountCodeFormValues = {
  [DISCOUNT_CODE_FIELD]: '',
};
